import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Container = styled.form`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
`
export const ContainerHeader = styled.div`
    display: flex;
    gap: 1rem;
`
export const ContainerInputs = styled.div`
    display: flex;
    flex-direction: column;
    width: 40%;
    gap: 1.2rem;
`

export const ContainerTables = styled.div`
    display: flex;
    width: 100%;
    gap: 1rem;
`

export const ContainerButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    width: 100%;
    gap: 1rem;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    height: 2.5rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const CustomButton = styled(ButtonMui)`
    width: 12rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`
